import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";
import StaticAreaSeries from "./StaticAreaSeries";

class FractalChaosBandsSeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForHigh = this.yAccessorForHigh.bind(this);
    this.yAccessorForLow = this.yAccessorForLow.bind(this);
    this.yAccessorForScaledLow = this.yAccessorForScaledLow.bind(this);
  }

  yAccessorForHigh(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).fractalHigh;
  }

  yAccessorForLow(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).fractalLow;
  }

  yAccessorForScaledLow(scale, d) {
    const { yAccessor } = this.props;
    return scale(yAccessor(d) && yAccessor(d).fractalLow);
  }

  render() {
    const { className, onDoubleClick, onContextMenu, channelFill } = this.props;
    const { strokeHigh, strokeLow, fill } = this.props;

    const resolvedStrokeHigh =
      typeof strokeHigh === "string" ? { color: strokeHigh } : strokeHigh;
    const resolvedStrokeLow =
      typeof strokeLow === "string" ? { color: strokeLow } : strokeLow;
    const resolvedFillColor =
      typeof fill === "string" ? { color: fill, opacity: 1 } : fill;
    const effectiveFillOpacity =
      channelFill === false ? 0 : resolvedFillColor.opacity;
    const areaStroke = { color: "none" };

    return (
      <g className={className} style={{ cursor: "pointer" }}>
        <LineSeries
          yAccessor={this.yAccessorForHigh}
          stroke={resolvedStrokeHigh}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <LineSeries
          yAccessor={this.yAccessorForLow}
          stroke={resolvedStrokeLow}
          fill="none"
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
        />
        <StaticAreaSeries
          className={`${className}-area`}
          yAccessor={this.yAccessorForHigh}
          base={this.yAccessorForScaledLow}
          stroke={areaStroke}
          fill={resolvedFillColor.color}
          opacity={effectiveFillOpacity}
        />
      </g>
    );
  }
}

FractalChaosBandsSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  className: PropTypes.string,
  strokeHigh: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  strokeLow: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
  fill: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  channelFill: PropTypes.bool,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

FractalChaosBandsSeries.defaultProps = {
  className: "react-stockcharts-fractal-chaos-bands-series",
  strokeHigh: { color: "#4CAF50" },
  strokeLow: { color: "#F44336" },
  fill: { color: "#8795A1", opacity: 0.1 },
  channelFill: true,
};

export default FractalChaosBandsSeries;
